export const aciHandle = {
    iconName: 'handle',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M3 7.5V5.25M5.25 7.5L3 5.25M21 19.313h-2.25v-.563A2.25 2.25 0 0121 16.5V21M16.5 3.834c.055-.203.167-.386.323-.53a1.15 1.15 0 011.184-.232c.2.074.375.201.505.368a1.115 1.115 0 01-.303 1.64c-.18.111-.39.17-.603.17.213 0 .422.058.603.169.181.11.327.268.422.456a1.11 1.11 0 01-.114 1.181 1.162 1.162 0 01-1.686.146 1.122 1.122 0 01-.327-.527M10.875 17.625a1.125 1.125 0 112.25 0c0 .364-.124.718-.351 1.002L10.875 21h2.25M8.625 3H9.75c.298 0 .585.06.796.165.21.105.329.248.329.397V7.5M8.625 7.5h2.25M4.125 3H3v2.25h1.125a1.125 1.125 0 000-2.25zM10.875 13.125v-2.25M17.625 13.125v-2.25M21 13.286c0-.228-.146-.446-.405-.606-.26-.161-.612-.251-.98-.251H5.77c-.734 0-1.439-.181-1.958-.502-.52-.322-.811-.758-.811-1.213',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
